import { utils } from "./utils";
import { responses } from "./responses";
import { errorHandler } from "./errorHandler";
import axios from "axios";
import Swal from "sweetalert2";

// window.pettyCashApi = 'https://lna.pos.co.zm/PettyCashApi/api/v1/';
// window.pettyCashApi = "https://lytningtomcat.chrilantech.com/lyt-petty-cash/";
window.pettyCashApi = "https://lytningtomcat.chrilantech.com/lyt-petty-cash/";

// window.subscriptionManager = 'http://mcc:8282/SubscriptionManager/';
window.subscriptionManager =
  "https://lytningtomcat.chrilantech.com/SubscriptionManager/";
window.serverApi = "https://lytningtomcat.chrilantech.com/OnlineSalesServer/";

window.KazangPaymentGatewayV2 = "https://lna.pos.co.zm/KazangPaymentGateway/";

// WhatsApp support number with country code
window.whatsAppNumber = "260958168829";

window.generateUUID = () => {
  let uuid = "",
    i,
    random;
  for (i = 0; i < 32; i++) {
    random = (Math.random() * 16) | 0;
    if (i === 8 || i === 12 || i === 16 || i === 20) {
      uuid += "-";
    }
    uuid += (i === 12 ? 4 : i === 16 ? (random & 3) | 8 : random).toString(16);
  }
  return uuid;
};

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 1500,
  showCloseButton: true,
  customClass: "toastr",
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

window.Toast = Toast;
window.responses = responses;
window.errorHandler = errorHandler;
window.$utils = utils;
window.axios = axios;
window.Swal = Swal;

// Sentry — DSN is a public key and is safe to ship in the client bundle.
window.sentryDsn = "https://acbbce7368d4bbd016f99be09ef6514c@o4511768463933440.ingest.de.sentry.io/4511783578239056";
window.sentryEnvironment = (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.MODE) || "production";
